import { render, staticRenderFns } from "./SocialNetworksEdit.vue?vue&type=template&id=de727b42&scoped=true"
import script from "./SocialNetworksEdit.vue?vue&type=script&lang=ts"
export * from "./SocialNetworksEdit.vue?vue&type=script&lang=ts"
import style0 from "./SocialNetworksEdit.vue?vue&type=style&index=0&id=de727b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de727b42",
  null
  
)

export default component.exports